import apiAxios from '../utils/apiAxios';


export const getPatients = async ({ queryKey }) => {
    const [, params] = queryKey;
    const { start, paginatedSize, firstname, lastname, dni } = params;
    const { data } = await apiAxios.get('patient', {
        params: {
            start,
            limit: paginatedSize,
            firstname,
            lastname,
            dni
        }
    });
    return data.data;
}

export const getPatientsAll = async ({ queryKey }) => {
    const [, params] = queryKey;
    const { firstname, lastname, dni } = params;
    const { data } = await apiAxios.get('patient/all', {
        params: { firstname, lastname, dni }
    });
    return data.data;
}

export const getDiagnosticsPatient = async (id) => {
    const { data } = await apiAxios.get(`patient/${id}/diagnostics`, {});
    return data.data;
}

export const createPatient = (data) => {
    return apiAxios.post(`patient`, data);
}

export const updatePatient = (id, data) => {
    return apiAxios.put(`patient/${id}`, data);
}

export const getDiagnosticsStates = async () => {
    const { data } = await apiAxios.get('pacientdiagnostico/states');
    return data.data;
}

export const updatePatientDiagnostico = (idPatientDiagnostico,idDiagnosticoDetail, data) => {
    return apiAxios.put(`patient-diagnostico/${idPatientDiagnostico}/detail/${idDiagnosticoDetail}`,data)
}

export const updatePatientDiagnosticoIcd = (idDiagnosticoIcd, data) => {
    return apiAxios.put(`pacientdiagnostico/${idDiagnosticoIcd}/diagnosticoIcd`,data)
}

export const updatePatientExamen = (idPatientExamen, data) => {
    return apiAxios.put(`patient-examen/${idPatientExamen}`,data)
}

export const deletePatientExamen = (idPatientExamen) => {
    return apiAxios.delete(`patient-examen/${idPatientExamen}`)
}

export const updatePatientExamenNew = (idPatientExamen, data) => {
    return apiAxios.put(`patient-examen-new/${idPatientExamen}`,data)
}

export const deletePatientExamenNew = (idPatientExamen) => {
    return apiAxios.delete(`patient-examen-new/${idPatientExamen}`)
}

// Historial de consentimientos del paciente. La constancia tiene que estar en la
// ficha clínica (apartado IX.A.2 de la Norma General Técnica N° 237), y lo que se
// devuelve es la secuencia completa y no sólo la última decisión: revocar agrega
// una fila, no modifica la anterior, y es esa secuencia la que sirve de evidencia.
export const getConsentimientosByPacient = async (id) => {
    const { data } = await apiAxios.get(`patient/${id}/consentimientos`, {});
    return data.data;
}

// Constancia de una oposición al apoyo automatizado que el paciente manifestó
// por otra vía —correo, teléfono, de palabra en la consulta—. `via` es cómo
// consta: sin ella la constancia dice que hubo una oposición y no cómo se supo.
// No reemplaza a la casilla del enlace del paciente: las dos vías conviven y
// gana la última.
// [v2] Una sola oposición, a toda la IA. La vía es obligatoria y la exige
// también el servidor: una constancia que no dice cómo consta no sirve después.
export const registrarOposicionApoyo = async (id, opone, via) => {
    const { data } = await apiAxios.post(`patient/${id}/oposicion-apoyo-automatizado`,
        { opone, via });
    return data.data;
}